import axios from "axios";
import { constant } from "../utils/constants";
import {
  EmptyLocalStorage,
  GetTokenLocalStorage,
  GetAuthUserLocalStorage,
} from "./localStorage/localStorage";

axios.defaults.baseURL = constant.BASE_URL;

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

api.interceptors.request.use(function (config) {
  const token = GetTokenLocalStorage();
  const authUser = GetAuthUserLocalStorage();

  config.headers.Authorization = token ? `bearer ${token}` : "";

  // Add salon context as header or query parameter for multi-salon support
  if (authUser?.salon?.id) {
    // Only add salon context if not explicitly provided in headers or params
    if (!config.headers["x-salon-id"]) {
      config.headers["x-salon-id"] = authUser.salon.id.toString();
    }
    // Initialize params if it doesn't exist
    if (!config.params) {
      config.params = {};
    }
    // Only add salon_id if it's not already present in the URL or params
    if (!config.params.salon_id && !config.url?.includes("salon_id=")) {
      config.params.salon_id = authUser.salon.id.toString();
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status == 401) {
      setTimeout(() => {
        EmptyLocalStorage();
        window.location.href = "/";
      }, 1500);
    }
    // return Promise.reject(error.response.data);
    return Promise.reject(error?.response?.data || { message: "Server Error" });
  },
);

export default api;
